/* eslint-disable @angular-eslint/prefer-inject, @angular-eslint/prefer-standalone -- Billing dialogs retain the module-based Material dialog contract. */
import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

export type PaygSwitchTiming = 'now' | 'renewal';

@Component({
    standalone: false,
    selector: 'app-payg-switch-dialog',
    templateUrl: './payg-switch-dialog.component.html',
    styleUrls: ['./payg-switch-dialog.component.scss'],
})
export class PaygSwitchDialogComponent
{
    constructor(
        @Inject(MAT_DIALOG_DATA) public readonly data: {renewalDate: string; alreadyScheduled: boolean},
        public readonly dialogRef: MatDialogRef<PaygSwitchDialogComponent, PaygSwitchTiming>,
    ) {}
}
